<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
            <div></div>
			<div>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiEnterpriseFacilitatorQueryList">刷新</a-button>
			</div>
		</div>

		
		<div class="qinang-card">
			<div >
				<a-breadcrumb >
                    <a-breadcrumb-item>
                        <a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
                            <a-form-model-item  label="绑定服务商" has-feedback  >
                                <a-select style="width: 80%;" mode="multiple" v-model="addForm.facilitatorIds" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择服务商">
                                    <a-select-option v-for="(item,index) in bindFacilitatorList" :value="item.facilitatorId" :key="index" :disabled="item.disabled">{{item.facilitatorName}}</a-select-option>
                                </a-select>
                                <a-button style="margin-left: 10px;" type="primary" @click="apiEnterpriseFacilitatorAdd" :loading="addConfirmLoading">绑定</a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </a-breadcrumb-item>
                </a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="id" :loading="tableLoading" :pagination="false">

			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
        props:{
			enterpriseId:{
				type:Number,
				default:""
			}
		},
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//服务商列表
				facilitatorList: [],
				//已绑定服务商列表
				bindList:[],
				//绑定服务上列表
				bindFacilitatorList:[],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					// facilitatorId: undefined,
					enterpriseId: undefined,
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    // { title:'ID', dataIndex:'id', key:'id', align:'center'},
					{ title:'服务商',dataIndex:'facilitatorName', key:'facilitatorName', align:'center'},
					
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					enterpriseId: undefined,
					facilitatorId: undefined,
					facilitatorIds: [],
                    // enterpriseId: undefined,
				},
				addRules: {
					
				},
				// 添加弹窗-end

			};
		},
		methods: {
            //获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,this.query);
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.facilitator2bindFacilitatorList()
				} else {
					this.$message.error(res.msg)
				}
			},

			facilitator2bindFacilitatorList(){
				let bindFacilitatorList = []
				for(let i = 0; i < this.facilitatorList.length; i++){
					bindFacilitatorList.push({
						facilitatorId:this.facilitatorList[i].facilitatorId,
						facilitatorName:this.facilitatorList[i].facilitatorName,
						disabled:this.bindList.find(item=>item.facilitatorId==this.facilitatorList[i].facilitatorId)== null?false:true
					})
				}
				this.bindFacilitatorList = bindFacilitatorList
			},

			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			//获取已绑定服务商列表
			async apiEnterpriseFacilitatorList(){
				const {
					data:res
				} = await this.$http.post(this.navigation.apiEnterpriseFacilitatorList,{enterpriseId:this.enterpriseId})
				if(res.code == 200){
					this.bindList = res.data
				}
			},

			//--------------表格开始-搜索
			async apiEnterpriseFacilitatorQueryList() {
				this.tableLoading = true
                let query = this.query
                query.enterpriseId = this.enterpriseId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseFacilitatorQueryList, query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiEnterpriseFacilitatorQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiEnterpriseFacilitatorQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			async apiEnterpriseFacilitatorAdd() {
				if(this.addForm.facilitatorIds.length == 0){
					this.$message.error("请选择服务商")
					return false
				}
				this.addConfirmLoading = true
				this.addForm.enterpriseId = this.enterpriseId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseFacilitatorAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.addForm ={}
					this.resetBindList()
					this.apiEnterpriseFacilitatorQueryList()
				} else {
					this.$message.error(res.msg)
				}
				this.addConfirmLoading = false
			},


			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.id)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiEnterpriseFacilitatorDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiEnterpriseFacilitatorDel(ids) {
				console.log(ids)
				const {
					data: res
				} = await this.$http.post(this.navigation.apiEnterpriseFacilitatorDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.resetBindList()
					this.apiEnterpriseFacilitatorQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			resetBindList(){
				this.apiEnterpriseFacilitatorList().then(()=>{
					this.facilitator2bindFacilitatorList()
				})
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
			this.apiEnterpriseFacilitatorList().then(() => {
				this.apiFacilitatorList()
				this.apiEnterpriseFacilitatorQueryList()
			})
		}
	};
</script>

<style scoped>
	.qinang-card ::v-deep .ant-form-item{
		margin-bottom: 0;
	}
</style>
